export const LogoMark = ({ size = 40 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <rect width="64" height="64" fill="#0B192C" />
        <rect x="5.5" y="5.5" width="53" height="53" fill="none" stroke="#B89047" strokeWidth="1.4" />
        <text
            x="32"
            y="41"
            textAnchor="middle"
            fontFamily="Georgia, 'Times New Roman', serif"
            fontSize="24"
            letterSpacing="1"
            fill="#F6F5F2"
        >
            DR
        </text>
    </svg>
);
